import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

function index({ children, title }) {
  return (
    <div className='flex-colo bg-dry xl:h-screen'>
      <div className='grid w-full xl:grid-cols-12 2xl:max-w-[2000px]'>
        <div className='col-span-1 hidden xl:block'>
          <Sidebar />
        </div>
        <div className='relative col-span-11 overflow-y-scroll xl:h-screen'>
          <Header title={title} />
          <div className='px-1 pt-4'>{children}</div>
        </div>
      </div>
    </div>
  );
}

export default index;
